import * as React from 'react';

import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { Box, Typography, useTheme } from '@mui/material';
import "./CalendarioMesPanel.css"
import MesCard from './MesCard';

const semana = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];


export default function CalendarioMesPanel(props) {
    const {data, eventos, setShowEvento, setIdEvento, feriado,setData,setCalendarType} = props;
    const [dias, setDias] = React.useState([]);
    const theme = useTheme();

    React.useEffect(()=>{        
        if( data){
            create();            
        }        
    },[data])

    function create(){        
        let dt1 = new Date(data);
        
        let dt2 = new Date(data);
        dt1.setDate(0);
        
        dt2.setUTCMonth( dt2.getUTCMonth()+1);
        dt2.setDate(0);
        
        let week = dt1.getDay();
        
        dt1.setDate( dt1.getDate()-week);
        
        let currentDate = new Date(dt1);
        let arr = [];
        while (currentDate <= dt2) {
            arr.push( new Date(currentDate));
            currentDate.setDate(currentDate.getDate() + 1);
        }
        week = currentDate.getDay();
        while( week < semana.length){
            arr.push( new Date(currentDate));
            currentDate.setDate(currentDate.getDate() + 1);            
            week++;
        }

        setDias(arr);
    }

    function formataData(dt){
        return dt.toLocaleDateString();
    }

    return (
        <Box sx={{ mb: 3, width: '100%' }}>
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(7, 1fr)',
                    gap: '1px',
                    bgcolor: theme.palette.divider,
                    border: `1px solid ${theme.palette.divider}`,
                    borderRadius: 1,
                    overflow: 'hidden'
                }}
            >
                {semana.map((s, id) => (
                    <Box
                        key={`dia-${id}`}
                        sx={{
                            bgcolor: theme.palette.grey[50],
                            py: 1,
                            textAlign: 'center'
                        }}
                    >
                        <Typography variant="subtitle2" color="text.secondary" fontWeight="bold">
                            {s}
                        </Typography>
                    </Box>
                ))}

                {dias && dias.map((d, id) => (
                    <Box
                        key={`cel-${id}`}
                        sx={{
                            bgcolor: 'background.paper',
                            minHeight: '120px',
                            transition: 'background-color 0.2s',
                            '&:hover': {
                                bgcolor: theme.palette.action.hover,
                            }
                        }}
                    >
                        <MesCard
                            data={d}
                            dataCorrent={data}
                            eventos={eventos}
                            setShowEvento={setShowEvento}
                            setIdEvento={setIdEvento}
                            feriado={feriado}
                            setData={setData}
                            setCalendarType={setCalendarType}
                        />
                    </Box>
                ))}
            </Box>
        </Box>
    );
}
